module.exports = __webpack_public_path__ + "static/img/t3@2x.aff4cbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/picture/t3@2x.jpg
// module id = 9ZIJ
// module chunks = 1